import React, {Component} from 'react';
import {YesNoModal} from "../../elements/YesNoModal";
import {FaIcon} from "../../FaIcon";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {ReconnectAdAccountModal} from "./ReconnectAdAccountModal";
import {TIENDA_NUBE_CHANNEL} from "../../channels/channels";

export class AdAccountDataRow extends Component {
    constructor(props) {
        super(props);
        this.handleAdAccountRemove = this.handleAdAccountRemove.bind(this);
        this.handleAdAccountReconnect = this.handleAdAccountReconnect.bind(this);
    }

    handleAdAccountRemove() {
        this.props.onRemove(this.props.adAccountData.ad_account_id)
    }

    handleAdAccountReconnect() {
        this.reconnectModal.toggle();
    }

    renderAccessStatus() {
        const icon = this.adAccountIsOk() ? "check" : "exclamation-triangle";
        const extraClassOnError = this.adAccountIsOk() ? "" : "no-impressions-alert";
        const noAccessTextDetail = this.props.adAccountData.has_access ? "" : <span style={{fontWeight: "600"}}>Sin acceso desde: {this.props.adAccountData.no_access_since}<br/></span>;

        return (
            <div className={"bu-cell-icon " + extraClassOnError}>
                <FaIcon iconName={icon}/>
                <div className="bu-tooltip">
                    <FaIcon iconName={icon}/>
                    <p className="tooltip-description">
                        {noAccessTextDetail}
                        Último chequeo: {this.props.adAccountData.last_access_check}
                    </p>
                </div>
            </div>
        );
    }

    adAccountIsOk() {
        return this.props.adAccountData.has_access
    }

    renderAuthorizesCell() {
        if (this.props.adAccountData.channel === TIENDA_NUBE_CHANNEL) {
            return null;
        }
        return <td>{this.props.adAccountData.email}</td>;
    }

    render() {
        return (
            <tr key={this.props.adAccountData.ad_account_id}>
                <td style={{paddingLeft: '0.4em'}}>{this.renderAccountColumnText()}</td>
                <td>{this.props.adAccountData.url}</td>
                {this.renderAuthorizesCell()}
                <td>{this.props.adAccountData.agency_client_names}</td>
                <td>{this.renderAccessStatus()}</td>
                <td>
                    <span style={{marginLeft: "5px", cursor: "pointer"}} onClick={this.handleAdAccountReconnect} title="Reconectar cuenta"> <FaIcon iconName="sync-alt"/></span>
                    <ReconnectAdAccountModal ref={instance => { this.reconnectModal = instance; }} adAccountData={this.props.adAccountData} onReconnected={() => window.location.reload()} />
                    <span style={{marginLeft: "5px"}}>
                        <YesNoModal onYesAnswer={this.handleAdAccountRemove}
                                    title={"Eliminar conexión y desvincular la tienda de clientes"}
                                    message={"Si elimina la conexión y desvincula la tienda se desactivarán las líneas de control que la utilizan y no podrá acceder a sus datos en Looker Studio. No se efectuará ningún cambio sobre la tienda misma."}
                                    question={"¿Desea continuar?"}
                                    buttonClassName={""}
                                    buttonText={""}
                                    buttonTitle="Eliminar conexión y desvincular tienda del cliente"
                                    buttonIconName={"minus-square"}
                                    isSaving={this.props.isSaving}
                        />
                    </span>
                </td>
            </tr>
        );
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width="20px" height={"20px"} channel={this.props.adAccountData.channel}
                                 marginLeft={"5px"}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.adAccountData.account_id}<br/>{this.props.adAccountData.name}
                </span>
            </div>
        )
    }
}
